import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import '../sass/news_detail.sass';
require('waypoints/lib/noframework.waypoints.js')
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { 
    faArrowLeft,
    // 以下共用
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { 
    // 以下共用
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'

library.add(
    faArrowLeft,
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,
)
dom.watch()

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
var controller = new ScrollMagic.Controller();

var scene = new ScrollMagic.Scene({ triggerElement: ".main-tit" })
    .setTween(".fixed_left .img", .5, { x: "0px", "opacity": "1" }) // trigger a TweenMax.to tween
    .addTo(controller);


$(function() {

    fixedLeft(".news_bg")
    $('main').addClass('newsMain')

})